export function endsWith(text: string, toFind: string): boolean {
    return text.endsWith(toFind);
}
